import { render, staticRenderFns } from "./CoeWeek.vue?vue&type=template&id=73e7148d&functional=true&"
var script = {}
import style0 from "./CoeWeek.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e7148d')) {
      api.createRecord('73e7148d', component.options)
    } else {
      api.rerender('73e7148d', component.options)
    }
    module.hot.accept("./CoeWeek.vue?vue&type=template&id=73e7148d&functional=true&", function () {
      api.rerender('73e7148d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CoeWeek.vue"
export default component.exports